<template>
  <div v-if="confidence != null" class="flex flex-col gap-2.5">
    <!-- Уверенность AI -->
    <div class="ai-stat ai-stat--ok">
      <div class="flex justify-between items-start">
        <div
          class="ai-stat__icon ai-stat__icon--ok flex items-center justify-center shrink-0"
        >
          <svg-icon name="huge-ai" class="w-3.5 h-3.5 fill-none" />
        </div>
        <div class="ai-stat__value flex items-baseline gap-0.5">
          <div class="ai-stat__num tabular-nums">{{ displayedConfidence }}</div>
          <div class="ai-stat__pct">%</div>
        </div>
      </div>
      <div class="ai-stat__label">
        {{ $t("Уверенность AI") }}
      </div>
    </div>
    <!-- Вероятность отказа -->
    <div class="ai-stat ai-stat--bad">
      <div class="flex justify-between items-start">
        <div
          class="ai-stat__icon ai-stat__icon--bad flex items-center justify-center shrink-0"
        >
          <svg-icon name="sli-danger" class="w-3.5 h-3.5 fill-none" />
        </div>
        <div
          class="ai-stat__value ai-stat__value--bad flex items-baseline gap-0.5"
        >
          <div class="ai-stat__num tabular-nums">{{ displayedRefusal }}</div>
          <div class="ai-stat__pct">%</div>
        </div>
      </div>
      <div class="ai-stat__label">
        {{ $t("Риск отказа") }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, toRef } from "vue";
import { useCountUp } from "./useCountUp";

const props = defineProps({
  confidence: { type: Number, default: null },
  refusalProb: { type: Number, default: null },
  enabled: { type: Boolean, default: true },
});

const enabledRef = toRef(props, "enabled");
const confidenceTarget = computed(() => Number(props.confidence) || 0);
const refusalTarget = computed(() => Number(props.refusalProb) || 0);

const { current: confidenceCurrent } = useCountUp(confidenceTarget, {
  duration: 900,
  enabled: enabledRef,
});
const { current: refusalCurrent } = useCountUp(refusalTarget, {
  duration: 900,
  enabled: enabledRef,
});
const displayedConfidence = computed(() => Math.round(confidenceCurrent.value));
const displayedRefusal = computed(() => Math.round(refusalCurrent.value));
</script>

<style lang="scss" scoped>
.ai-stat {
  @apply flex flex-col gap-1.5 rounded border border-solid border-border bg-card;
  padding: 10px 12px;

  &__icon {
    width: 24px;
    height: 24px;
    @apply rounded border border-solid;

    &--ok {
      @apply bg-indigo-50 border-indigo-100;
      color: rgb(var(--color-indigo-500));
    }

    &--bad {
      @apply bg-red-50 border-red-100;
      color: rgb(var(--color-red-400));
    }
  }

  &__value {
    color: rgb(var(--color-indigo-500));

    &--bad {
      color: rgb(var(--color-red-500));
    }
  }

  &__num {
    @apply font-semibold;
    font-size: 16px;
    letter-spacing: -0.01em;
    line-height: 1;
  }

  &__pct {
    font-size: 11px;
  }

  &__label {
    font-size: 12px;
    line-height: 1.4;
    color: rgb(var(--color-gray-600));
    font-weight: 700;
  }
}
</style>
